import { PageNames } from '@libs/acp/common/types/accessPermissions';

export enum RouteMap {
  Root = '/',
  SignIn = '/login',
  SignUp = '/cadastro',
  signupACPErrorKBA = '/cadastro/erro-informacoes',
  recoveryPasswordACPErrorKBA = '/recuperar-senha/erro-informacoes',
  signinACPFailedDocument = '/falha-ao-validar-documento',
  signupACPBlockedKBA = '/cadastro/falha-ao-validar-informacoes',
  signupACPBlockedLGPD = '/cadastro/bloqueio-de-seguranca',
  recoveryACPBlockedKBA = '/recuperar-senha/falha-ao-validar-informacoes',
  SignUpPartnerPartial = '/cadastro-via-parceiro',
  HomePartner = '/home-partner',
  SignUpPartnerCompleted = '/cadastro-via-parceiro-completo',
  SignUpNCADCompleted = '/cadastro-ncad-completo',
  ForgotPassword = '/recuperar-senha',
  RedefinePassword = '/redefinir-senha',
  RedefinePasswordInvalidKBA = '/redefinir-senha/erro-informacoes',
  RedefinePasswordBlockedKBA = '/redefinir-senha/falha-ao-validar-informacoes',
  Pin = '/pin',
  UserProfile = '/minha-conta',
  AccountDeletion = '/minha-conta/deletar-conta',
  ChangePassword = '/alterar-senha',
  ChangePasswordSuccess = '/alterar-senha/sucesso',
  ChangeEmail = '/minha-conta/alterar-email',
  ChangePhone = '/atualizar-contato/telefone',
  ChangeSocialName = '/atualizar-nome-social',
  ChangeContactSuccess = '/atualizar-contato/sucesso',
  UpdateExpiredEmail = '/atualizar-contato/email',
  ValidateCoflictingEmailEmail = '/validar-contato/email',
  SigninUnifyPasswordACP = '/unificar-senha',
  Notification = '/notificacoes',
  Logout = '/sair',
  Dashboard = '/home',
  Score = '/score',
  Objectives = '/meus-objetivos',
  ObjectiveDetail = '/meus-objetivos/detalhe',
  ObjectivesHistoric = '/meus-objetivos/historico',
  NegativeDebts = '/debitos-negativados',
  Offer = '/ofertas',
  OfferDetails = '/ofertas/:slug',
  ProductDetail = '/oferta-detalhada/:slug',
  MyFavorites = '/meus-favoritos',
  Help = '/ajuda',
  CpfLookout = '/consultas-cpf',
  BillsAndPayments = '/contas-pagamentos',
  BillsProductList = '/contas-pagamentos/categorias',
  BillsProductDetail = '/contas-pagamentos/produto',
  BillsInstallmentDetail = '/contas-pagamentos/parcela',
  MyDebts = '/debitos',
  MyDebtsAC = '/minhas-dividas',
  MyAgreementsAC = '/meus-acordos',
  MatchMaker = '/comparador',
  MatchMakerResult = '/comparador/sucesso',
  CpfAlert = '/alerta-cpf',
  ActivityHistory = '/alerta-cpf/historico',
  CpfReport = '/relatorio-cpf',
  Otp = '/otp',
  MyScore = '/meu-score',
  MyOffers = '/minhas-ofertas',
  MyCpf = '/meu-cpf',
  FullFunnelRedirect = '/analisando-oferta',
  PreApprovedOffers = '/ofertas-pre-aprovadas',
  TicketApprovedOffers = '/ofertas-selecionadas-ticket',
	MFAPositiveData = '/validar-identidade/cadastro-positivo',
}

export const titleMap: Record<string, string> = {
  [RouteMap.Root]: 'Início',
  [RouteMap.SignIn]: 'Logar',
  [RouteMap.Otp]: 'Logar',
  [RouteMap.SignUp]: 'Cadastro',
  [RouteMap.signupACPErrorKBA]: 'Cadastro - Informações inválidas',
  [RouteMap.signupACPBlockedKBA]: 'Cadastro - Não foi possível validar as informações',
  [RouteMap.signupACPBlockedLGPD]: 'Cadastro - Por questões de segurança, o cadastro foi bloqueado',
  [RouteMap.SignUpNCADCompleted]: 'Cadastro NCAD Completo',
  [RouteMap.signinACPFailedDocument]: 'Login - Não foi possível validar o documento',
  [RouteMap.ForgotPassword]: 'Recuperar a senha',
  [RouteMap.RedefinePassword]: 'Redefinir senha',
  [RouteMap.RedefinePasswordInvalidKBA]: 'Redefinir Senha - Informações inválidas',
  [RouteMap.RedefinePasswordBlockedKBA]: 'Redefinir Senha - Não foi possível validar as informações',
  [RouteMap.Pin]: 'Pin',
  [RouteMap.UserProfile]: 'Minha conta',
  [RouteMap.ChangePassword]: 'Alterar senha',
  [RouteMap.ChangePasswordSuccess]: 'Senha alterada com sucesso',
  [RouteMap.ChangeEmail]: 'Alterar e-mail',
  [RouteMap.ChangeContactSuccess]: 'E-mail alterado com sucesso',
  [RouteMap.Notification]: 'Notificações',
  [RouteMap.Logout]: 'Sair',
  [RouteMap.Dashboard]: 'Home',
  [RouteMap.Score]: 'Score',
  [RouteMap.Objectives]: 'Meus Objetivos',
  [RouteMap.ObjectiveDetail]: 'Detalhes',
  [RouteMap.ObjectivesHistoric]: 'Meu histórico',
  [RouteMap.NegativeDebts]: 'Débitos negativados',
  [RouteMap.Offer]: 'Ofertas',
  [RouteMap.OfferDetails]: 'Ofertas - Detalhes',
  [RouteMap.ProductDetail]: 'Oferta Detalhada',
  [RouteMap.Help]: 'Ajuda',
  [RouteMap.CpfLookout]: 'Consultas CPF',
  [RouteMap.BillsAndPayments]: 'Contas e Pagamentos',
  [RouteMap.BillsProductList]: 'Contas e pagamentos - Categorias',
  [RouteMap.BillsProductDetail]: 'Contas e pagamentos - Produto',
  [RouteMap.BillsInstallmentDetail]: 'Contas e pagamentos - Parcela',
  [RouteMap.MyDebts]: 'Minhas dividas',
  [RouteMap.MyDebtsAC]: 'Minhas dividas',
  [RouteMap.MatchMaker]: 'Comparador',
  [RouteMap.CpfAlert]: 'Alerta CPF',
  [RouteMap.CpfReport]: 'Relatório do meu CPF',
  [RouteMap.MyScore]: 'Meu Score',
  [RouteMap.MyOffers]: 'Minhas Ofertas',
  [RouteMap.MyCpf]: 'Meu CPF',
  [RouteMap.FullFunnelRedirect]: 'Analisando Oferta',
  [RouteMap.PreApprovedOffers]: 'Ofertas pré aprovadas',
  [RouteMap.TicketApprovedOffers]: 'Ofertas Selecionadas',
	[RouteMap.MFAPositiveData]: 'Validar identidade - Cadastro positivo',
};

//TODO: padronizando igual a estrutura do AC pra poder add feat de token permission,
// posteriormente migraremos os lugares que estao usando os mappers
// pra esse novo obj
export const pageNames: PageNames = {
  root: {
    path: '/',
    type: 'public',
    name: 'Início',
    permissionsToAccess: ['all'],
  },
  signIn: {
    path: '/login',
    type: 'public',
    name: 'Logar',
    permissionsToAccess: [],
  },
  signUp: {
    path: '/cadastro',
    type: 'public',
    name: 'Cadastro',
    permissionsToAccess: [],
  },
  signupACPErrorKBA: {
    path: '/cadastro/erro-informacoes',
    type: 'public',
    name: 'Cadastro - Informações inválidas',
    permissionsToAccess: [],
  },
  recoveryPasswordACPErrorKBA: {
    path: '/recuperar-senha/erro-informacoes',
    type: 'public',
    name: 'Recuperar Senha - Informações inválidas',
    permissionsToAccess: [],
  },
	redefinePassword: {
    path: '/redefinir-senha',
    type: 'public',
    name: 'Redefinir senha',
  },
	resetPasswordACPInvalidKBA: {
    path: '/redefinir-senha/erro-informacoes',
    type: 'public',
    name: 'Recuperar Senha',
  },
  resetPasswordACPBlockedKBA: {
    path: '/redefinir-senha/falha-ao-validar-informacoes',
    type: 'public',
    name: 'Recuperar Senha',
  },
  signinACPFailedDocument: {
    path: '/falha-ao-validar-documento',
    type: 'public',
    name: 'Login - Não foi possível validar o documento',
    permissionsToAccess: [],
  },
  signupACPBlockedKBA: {
    path: '/cadastro/falha-ao-validar-informacoes',
    type: 'public',
    name: 'Cadastro - Não foi possível validar as informações',
    permissionsToAccess: [],
  },
  recoveryACPBlockedKBA: {
    path: '/recuperar-senha/falha-ao-validar-informacoes',
    type: 'public',
    name: 'Recuperar Senha - Não foi possível validar as informações',
    permissionsToAccess: [],
  },
  signUpPartnerPartial: {
    path: '/cadastro-via-parceiro',
    type: 'public',
    name: 'Cadastro via parceiro',
    permissionsToAccess: [],
  },
  homePartner: {
    path: '/home-partner',
    type: 'private',
    name: 'Home Parceiro',
    permissionsToAccess: [],
  },
  signUpPartnerCompleted: {
    path: '/cadastro-via-parceiro-completo',
    type: 'public',
    name: 'Cadastro via parceiro completo',
    permissionsToAccess: [],
  },
  signUpNCADCompleted: {
    path: '/cadastro-ncad-completo',
    type: 'public',
    name: 'Cadastro NCAD Completo',
    permissionsToAccess: [],
  },
  forgotPassword: {
    path: '/recuperar-senha',
    type: 'public',
    name: 'Recuperar a senha',
    permissionsToAccess: [],
  },
  pin: {
    path: '/pin',
    type: 'public',
    name: 'Pin',
    permissionsToAccess: [],
  },
  userProfile: {
    path: '/minha-conta',
    type: 'private',
    name: 'Minha conta',
    permissionsToAccess: ['all', 'customer'],
  },
  accountDeletion: {
    path: '/minha-conta/deletar-conta',
    type: 'private',
    name: 'Deletar conta',
    permissionsToAccess: ['all', 'customer'],
  },
  changePassword: {
    path: '/alterar-senha',
    type: 'private',
    name: 'Alterar senha',
    permissionsToAccess: ['all', 'customer', 'customer:write:data'],
  },
  changePasswordSuccess: {
    path: '/alterar-senha/sucesso',
    type: 'private',
    name: 'Senha alterada com sucesso',
    permissionsToAccess: ['all', 'customer', 'customer:write:data'],
  },
  changeEmail: {
    path: '/minha-conta/alterar-email',
    type: 'private',
    name: 'Alterar e-mail',
    permissionsToAccess: ['all', 'customer', 'customer:write:data'],
  },
  changeContactSuccess: {
    path: '/atualizar-contato/sucesso',
    type: 'private',
    name: 'Contato atualizado com sucesso',
    permissionsToAccess: ['all', 'customer', 'customer:write:data'],
  },
  updateExpiredEmail: {
    path: '/atualizar-contato/email',
    type: 'private',
    name: 'Atualizar e-mail',
    permissionsToAccess: ['all', 'customer', 'customer:write:data'],
  },
  updatePhoneACP: {
    path: '/atualizar-contato/telefone',
    type: 'private',
    name: 'Atualizar Telefone',
    permissionsToAccess: ['all', 'customer', 'customer:write:data'],
  },
  updateSocialName: {
    path: '/atualizar-nome-social',
    type: 'private',
    name: 'Atualizar Nome Social',
    permissionsToAccess: ['all', 'customer', 'customer:write:data'],
  },
  validateCoflictingEmailEmail: {
    path: '/validar-contato/email',
    type: 'private',
    name: 'Validar e-mail',
    permissionsToAccess: ['all', 'customer', 'customer:write:data'],
  },
  signinUnifyPasswordACP: {
    path: '/unificar-senha',
    type: 'private',
    name: 'Unificar senha',
    permissionsToAccess: ['all', 'customer', 'customer:write:data'],
  },
  notification: {
    path: '/notificacoes',
    type: 'private',
    name: 'Notificações',
    permissionsToAccess: ['all'],
  },
  logout: {
    path: '/sair',
    type: 'public',
    name: 'Sair',
  },
  dashboard: {
    path: '/home',
    type: 'private',
    name: 'Home',
    permissionsToAccess: [
      'all',
      'renegociate_debts',
      'read_debts',
      'reneg',
      'reneg:read:debts',
      'reneg:read:agreements',
      'reneg:feature:renegociate',
      'credit',
      'score',
      'score:read:score',
    ],
  },
  score: {
    path: '/score',
    type: 'private',
    name: 'Score',
    permissionsToAccess: ['all', 'score', 'score:read:score', 'score:read:positive_data'],
  },
  objectives: {
    path: '/meus-objetivos',
    type: 'private',
    name: 'Meus Objetivos',
    permissionsToAccess: ['all', 'score', 'score:read:score', 'score:read:positive_data'],
  },
  objectiveDetail: {
    path: '/meus-objetivos/detalhe',
    type: 'private',
    name: 'Detalhes',
    permissionsToAccess: ['all', 'score', 'score:read:score', 'score:read:positive_data'],
  },
  objectivesHistoric: {
    path: '/meus-objetivos/historico',
    type: '',
    name: 'Meu histórico',
    permissionsToAccess: ['all', 'score', 'score:read:score', 'score:read:positive_data'],
  },
  negativeDebts: {
    path: '/debitos-negativados',
    type: 'private',
    name: 'Débitos negativados',
    permissionsToAccess: [
      'all',
      'renegociate_debts',
      'read_debts',
      'reneg',
      'reneg:read:debts',
      'reneg:read:agreements',
      'reneg:feature:renegociate',
    ],
  },
  offer: {
    path: '/ofertas',
    type: 'private',
    name: 'Ofertas',
    permissionsToAccess: ['all', 'credit'],
  },
  offerDetails: {
    path: '/ofertas/:slug',
    type: 'private',
    name: 'Ofertas - Detalhes',
    permissionsToAccess: ['all', 'credit'],
  },
  productDetail: {
    path: '/oferta-detalhada/:slug',
    type: 'private',
    name: 'Oferta Detalhada',
    permissionsToAccess: ['all', 'credit'],
  },
  myFavorites: {
    path: '/meus-favoritos',
    type: 'private',
    name: 'Meus Favoritos',
    permissionsToAccess: ['all'],
  },
  help: {
    path: '/ajuda',
    type: 'public',
    name: 'Ajuda',
    permissionsToAccess: [],
  },
  cpfLookout: {
    path: '/consultas-cpf',
    type: 'private',
    name: 'Consultas CPF',
    permissionsToAccess: ['all'],
  },
  billsAndPayments: {
    path: '/contas-pagamentos',
    type: 'private',
    name: 'Contas e Pagamentos',
    permissionsToAccess: ['all'],
  },
  billsProductList: {
    path: '/contas-pagamentos/categorias',
    type: 'private',
    name: 'Contas e pagamentos - Categorias',
    permissionsToAccess: ['all'],
  },
  billsProductDetail: {
    path: '/contas-pagamentos/produto',
    type: 'private',
    name: 'Contas e pagamentos - Produto',
    permissionsToAccess: ['all'],
  },
  billsInstallmentDetail: {
    path: '/contas-pagamentos/parcela',
    type: 'private',
    name: 'Contas e pagamentos - Parcela',
    permissionsToAccess: ['all'],
  },
  myDebts: {
    path: '/debitos',
    type: 'private',
    name: 'Minhas dividas',
    permissionsToAccess: [
      'all',
      'renegociate_debts',
      'read_debts',
      'reneg',
      'reneg:read:debts',
      'reneg:read:agreements',
      'reneg:feature:renegociate',
    ],
  },
  myDebtsAC: {
    path: '/minhas-dividas',
    type: 'private',
    name: 'Minhas dividas',
    permissionsToAccess: [
      'all',
      'renegociate_debts',
      'read_debts',
      'reneg',
      'reneg:read:debts',
      'reneg:read:agreements',
      'reneg:feature:renegociate',
    ],
  },
  myAgreementsAC: {
    path: '/meus-acordos',
    type: 'private',
    name: 'Meus acordos',
    permissionsToAccess: [
      'all',
      'renegociate_debts',
      'read_debts',
      'read_agreements',
      'reneg',
      'reneg:read:debts',
      'reneg:read:agreements',
      'reneg:feature:renegociate',
    ],
  },
  matchMaker: {
    path: '/comparador',
    type: 'private',
    name: 'Comparador',
    permissionsToAccess: ['all'],
  },
  matchMakerResult: {
    path: '/comparador/sucesso',
    type: 'private',
    name: 'Comparador - Sucesso',
    permissionsToAccess: ['all'],
  },
  cpfAlert: {
    path: '/alerta-cpf',
    type: 'private',
    name: 'Alerta CPF',
    permissionsToAccess: ['all', 'score', 'score:read:score'],
  },
  activityHistory: {
    path: '/alerta-cpf/historico',
    type: 'private',
    name: 'Histórico de Atividade',
    permissionsToAccess: ['all', 'score', 'score:read:score'],
  },
  cpfReport: {
    path: '/relatorio-cpf',
    type: 'private',
    name: 'Relatório do meu CPF',
    permissionsToAccess: ['all', 'score', 'score:read:score'],
  },
  otp: {
    path: '/otp',
    type: 'public',
    name: 'Logar',
  },
  myScore: {
    path: '/meu-score',
    type: 'private',
    name: 'Meu Score',
    permissionsToAccess: ['all', 'score', 'score:read:score'],
  },
  myOffers: {
    path: '/minhas-ofertas',
    type: 'private',
    name: 'Minhas Ofertas',
    permissionsToAccess: ['all', 'credit'],
  },
  myCpf: {
    path: '/meu-cpf',
    type: 'private',
    name: 'Meu CPF',
    permissionsToAccess: ['all', 'score', 'score:read:score'],
  },
  fullFunnelRedirect: {
    path: '/analisando-oferta',
    type: 'private',
    name: 'Analisando Oferta',
    permissionsToAccess: ['all', 'credit'],
  },
  preApprovedOffers: {
    path: '/ofertas-pre-aprovadas',
    type: 'private',
    name: 'Ofertas pré aprovadas',
    permissionsToAccess: ['all', 'credit'],
  },
  ticketApprovedOffers: {
    path: '/ofertas-selecionadas-ticket',
    type: 'private',
    name: 'Ofertas Selecionadas',
    permissionsToAccess: ['all', 'credit'],
  },
	unlockProtectedFeature: {
    path: '/validar-identidade',
    type: 'private',
    name: 'Validar identidade',
    permissionsToAccess: [
      'reneg',
      'reneg:read:debts',
      'reneg:read:agreements',
      'reneg:feature:renegociate',
      'score',
      'score:read:score',
      'score:read:hidden_score',
      'score:read:positive_data',
      'credit',
      'customer',
      'customer:read:data',
      'customer:write:data',
    ],
  },
  unlockProtectedFeatureSuccess: {
    path: '/validar-identidade/sucesso',
    type: 'private',
    name: 'Identidade validada com sucesso',
    permissionsToAccess: ['all'],
  },
  unlockProtectedFeaturePassword: {
    path: '/validar-identidade/recuperar-senha',
    type: 'private',
    name: 'Recuperar Senha',
    permissionsToAccess: [
      'all',
      'score',
      'score:read:score',
      'score:read:hidden_score',
      'score:read:positive_data',
      'customer',
      'customer:read:data',
      'customer:write:data',
    ],
  },
  unlockProtectedFeatureACPInvalidKBA: {
    path: '/validar-identidade/recuperar-senha/erro-informacoes',
    type: 'private',
    name: 'KBA inválido',
    permissionsToAccess: ['all'],
  },
  unlockProtectedFeatureACPBlockedKBA: {
    path: '/validar-identidade/recuperar-senha/falha-ao-validar-informacoes',
    type: 'private',
    name: 'Falha ao validar informações',
    permissionsToAccess: ['all'],
  },
	mfaPositiveData: {
    path: '/validar-identidade/cadastro-positivo',
    type: 'private',
    name: 'Cadastro Positivo',
		permissionsToAccess: ['all'],
  },
};
